module.exports = __webpack_public_path__ + "static/media/bmw-go-drive.73ea6b5b.png";